export default "__VITE_ASSET__CWo7v011__"